module.exports = __webpack_public_path__ + "static/media/26.b6322ac3.png";